import { TabPosition } from '@progress/kendo-angular-layout';
import { Enum, EnumType } from 'ts-jenum';

@Enum<TabPositionType>('value')
export class TabPositionType extends EnumType<TabPositionType>() {
   public static readonly TOP = new TabPositionType('TOP', 'top', 'common.types.tab_position_type.top');
   public static readonly BOTTOM = new TabPositionType('BOTTOM', 'bottom', 'common.types.tab_position_type.bottom');
   public static readonly LEFT = new TabPositionType('LEFT', 'left', 'common.types.tab_position_type.left');
   public static readonly RIGHT = new TabPositionType('RIGHT', 'right', 'common.types.tab_position_type.right');

   private constructor(public value: string, public kendoValue: TabPosition, public translationKey: string) {
      super();
   }
}
